const SHORT_TITLE_SEPARATORS = [' – ', ' — ', ' - ', ': ']
const SHORT_TITLE_MAX = 24

/**
 * "Schedule J – Technical Response" → "Schedule J". The leading label before
 * the first separator, when there is one and it is short; otherwise the whole
 * title (the tag truncates it and the tooltip carries the full text).
 */
export function shortSubmissionTitle(title: string): string {
  const trimmed = title.trim()
  let cut = -1
  for (const separator of SHORT_TITLE_SEPARATORS) {
    const index = trimmed.indexOf(separator)
    if (index > 0 && (cut === -1 || index < cut)) cut = index
  }
  if (cut === -1) return trimmed
  const head = trimmed.slice(0, cut).trim()
  return head.length > 0 && head.length <= SHORT_TITLE_MAX ? head : trimmed
}
